import React, { Component } from 'react'
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import Button from 'react-bootstrap/lib/Button'

class TeamDashTagCollapseButtonGroup extends Component {
    constructor(props) {
        super(props)
    }

    onCollapsedClick = () => {
        this.props.onDisplayChange('collapsed')
    }

    onUncollapsedClick = () => {
        this.props.onDisplayChange('uncollapsed')
    }

    render() {
        const { display } = this.props
        return (
            <ButtonGroup>
                <Button onClick={this.onCollapsedClick} active={display === 'collapsed'}>
                    Collapsed by tag
                </Button>
                <Button onClick={this.onUncollapsedClick} active={display === 'uncollapsed'}>
                    Uncollapsed
                </Button>
            </ButtonGroup>
        )
    }
}

export default TeamDashTagCollapseButtonGroup


// WEBPACK FOOTER //
// ./src/components/team_tag_collapse_button_group.jsx